import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import UsageViewItem from '../UsageViewItem';

import styles from './UsageView.Styles';

function UsageView({
  usageData,
  images,
  containerStyle,
  onAddUsagePress,
  toggleAddUsageModal,
  planId,
  shouldShowAddUsageButton,
  ...props
}) {
  const theme = useTheme();

  return (
    <View style={[styles.containerStyle, containerStyle]}>
      {_map(usageData, item => {
        return (
          <View style={styles.usageItemContainerStyle(theme)}>
            <UsageViewItem
              shouldShowAddUsageButton={shouldShowAddUsageButton}
              images={images}
              onAddUsagePress={() => onAddUsagePress(item, toggleAddUsageModal, planId)}
              {...item}
            />
          </View>
        );
      })}
    </View>
  );
}

UsageView.defaultProps = {
  shouldShowAddUsageButton: true,
  isUser: false,
};

UsageView.propTypes = {
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      usedAmount: PropTypes.number,
      usedUnits: PropTypes.string,
      valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  planId: PropTypes.string,
  isUser: PropTypes.bool,
  images: PropTypes.object,
  containerStyle: ViewPropTypes.style,
  onAddUsagePress: PropTypes.func,
  toggleAddUsageModal: PropTypes.func,
  shouldShowAddUsageButton: PropTypes.bool,
};

export default UsageView;
